import EndScroll from 'app/components/endScroll';
import Loader from 'app/components/loader';
import { ApiClient } from 'jsonapi-react';
import { useEffect, useState } from 'react';
import toast from 'react-hot-toast';
import { AiOutlineTrophy } from 'react-icons/ai';
import { FiChevronDown } from 'react-icons/fi';
import InfiniteScroll from 'react-infinite-scroll-component';

export function LiveClassesTable({ searchValue, regionals, institutionsWithInep, institutionsWithoutInep, series, filters, currentFilters }) {
  const [hasMore, setHasMore] = useState(true);
  const [sortDirection, setSortDirection] = useState('desc');
  const [pageNumber, setPageNumber] = useState(1);
  const [data, setData] = useState([]);
  const [loadingTable, setLoadingTable] = useState(false);

  const apiSso = process.env.REACT_APP_SSO_API_URL;

  const client = new ApiClient({
    url: `${apiSso}/api/v1`
  });

  const sorted = data.sort((a, b) => {
    if (sortDirection === 'asc') {
      return a.registrationsCount - b.registrationsCount;
    } else {
      return b.registrationsCount - a.registrationsCount;
    }
  });

  const getTableData = async (page = 1, isNewSearch = false) => {
    let url = `/live_classroom_accesses?page[number]=${page}&page[size]=25&initial_date=${filters.values['start-date']}&final_date=${filters.values['end-date']}&sort_dir=${sortDirection}`;

    if (regionals.length > 0) {
      url += `&regional_code=${regionals.join(',')}`;
    }

    if (institutionsWithInep.length > 0) {
      url += `&institution_inep=${institutionsWithInep.join(',')}`;
    }

    if (institutionsWithoutInep.length > 0) {
      url += `&institution_name=${institutionsWithoutInep.join(',')}`;
    }
    if (series.length > 0) {
      url += `&source=${series.join(',')}`;
    }

    try {
      setLoadingTable(true);
      const { data, meta } = await client.fetch(url);
      if (data.length < 25) {
        setHasMore(false);
      }
      setData(prev => (isNewSearch ? data : [...prev, ...data]));
    } catch (error) {
      toast.error('Erro ao buscar os dados da tabela.');
    }
    setLoadingTable(false);
  };

  useEffect(() => {
    // if (isInitialMount.current) {
    //   isInitialMount.current = false;
    //   return;
    // }

    setData([]);
    setPageNumber(1);
    setHasMore(true);

    getTableData(1, true);
  }, [filters.values, currentFilters, sortDirection]);

  useEffect(() => {
    if (pageNumber > 1) {
      getTableData(pageNumber);
    }
  }, [pageNumber]);

  return (
    <div className="report-widget">
      <div className="report-widget__header">
        <div className="report-widget__inner">
          <h3 className="report-widget__title">Ranking de acessos a Aulas ao Vivo</h3>
        </div>
      </div>

      <div className="report-widget__body">
        <InfiniteScroll
          dataLength={data.length}
          next={() => {
            setPageNumber(pageNumber + 1);
          }}
          hasMore={hasMore}
          loader={<Loader />}
          endMessage={<EndScroll />}
        >
          <table
            className="round-dg round-dg--light"
            style={{ minWidth: '720px' }}
          >
            <thead className="round-dg__header">
              <tr className="round-dg__row">
                <th className="round-dg__cell-header round-dg__cell-header--sm">GRE</th>
                <th className="round-dg__cell-header round-dg__cell-header--sm">Escola</th>
                <th className="round-dg__cell-header round-dg__cell-header--sm u-text-right">
                  Quant. de acessos
                  <span
                    onClick={() => setSortDirection(sortDirection === 'asc' ? 'desc' : 'asc')}
                    className="card__icon-wrapper card__icon-wrapper--sm u-cursor-pointer ml-2"
                  >
                    <FiChevronDown
                      style={{ transform: sortDirection === 'desc' ? 'rotate(0deg)' : 'rotate(180deg)' }}
                      className="card__icon"
                    />
                  </span>
                </th>
              </tr>
            </thead>

            <tbody className="round-dg__body">
              {data.length > 0 &&
                sorted
                  .filter(item => !searchValue || item.name.toLowerCase().includes(searchValue))
                  .map((item, i) => (
                    <tr
                      key={item.id}
                      className={`round-dg__row u-cursor-default`}
                    >
                      <th className={`round-dg__cell-header round-dg__cell-header--sm round-dg__cell-header--row `}>
                        {' '}
                        {i === 0 && sortDirection === 'desc' && <AiOutlineTrophy className="card__icon card__icon--golden mr-3" />}
                        {i === 1 && sortDirection === 'desc' && <AiOutlineTrophy className="card__icon card__icon--silver mr-3" />}
                        {i === 2 && sortDirection === 'desc' && <AiOutlineTrophy className="card__icon card__icon--bronze mr-3" />}
                        {item.gre || '-'}
                      </th>
                      <td className="round-dg__cell round-dg__cell--sm">
                        <div className="round-dg__user">
                          <div className="round-dg__user-inner">
                            <h3 className="round-dg__title">{item.institution || '-'}</h3>
                          </div>
                        </div>
                      </td>
                      <td className="round-dg__cell round-dg__cell--sm u-text-right">{item['access-count'] || '-'}</td>
                    </tr>
                  ))}
            </tbody>
          </table>
        </InfiniteScroll>
      </div>
    </div>
  );
}
